/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';

export const Screen = styled.div`
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ErrorText = styled.p`
  margin: 0;
  padding: 0;

  font-family:
    Inter,
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 140%;
  text-align: center;

  color: #ff8a8a;
`;

export const ButtonsCol = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const PrimaryButton = styled.button`
  width: 100%;
  height: 44px;
  border-radius: 8px;
  padding: 10px;
  border: none;

  background: #5e84ed;

  font-family:
    Inter,
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;

  color: #ffffff;

  cursor: pointer;

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

export const SecondaryButton = styled.button`
  width: 100%;
  height: 44px;
  border-radius: 8px;
  padding: 10px;

  background: transparent;
  border: 1px solid transparent;

  font-family:
    Inter,
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;

  color: #b7bdcb;

  cursor: pointer;

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

export const SpinnerWrap = styled.div`
  margin-top: 12px;
  display: grid;
  place-items: center;
`;

export const Card = styled.div`
  padding: 16px;
  background: #1e1f22;
  border-radius: 12px;
  outline: 1px #2b2d33 solid;
  outline-offset: -1px;
  flex-direction: column;
  gap: 16px;
  display: inline-flex;
`;

export const Form = styled.form`
  display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const FieldRow = styled.div`
  display: inline-flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

export const FieldLabel = styled.span`
  color: #b7bdcb;
  font-size: 13px;
  font-family: Inter;
  font-weight: 500;
  line-height: 15.6px;
  word-wrap: break-word;
`;

export const FieldInput = styled.input`
  height: 38px;
  background: #23252a;
  border-radius: 12px;
  border: 2px #2b2d33 solid;
  outline: none;
  font-family:
    Inter,
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    sans-serif;
  font-weight: 400;
  font-size: 16px;
  color: #e9ecf5;
  padding: 0px 12px;
  outline: none;

  &:focus {
    border: 2px #5e84ed solid;
  }
`;

export const TopPart = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 24px 0px;
`;

export const FirstParagraph = styled.span`
  color: #e9ecf5;
  font-size: 16px;
  font-family: Inter;
  font-weight: 500;
  word-wrap: break-word;
  text-align: center;
`;

export const SecondParagraph = styled.span`
  color: #b7bdcb;
  font-size: 14px;
  font-family: Inter;
  font-weight: 500;
  word-wrap: break-word;
`;

export const Disclaimer = styled.span`
  text-align: center;
  color: #b7bdcb;
  font-size: 13px;
  font-family: Inter;
  font-weight: 400;
  line-height: 140%;
  word-wrap: break-word;
`;

export const Link = styled.a`
  color: #5e84ed;
  text-decoration: underline;
  cursor: pointer;
`;
